import { isProduction } from 'utils/helpers';

export const TOKEN_TYPE = 'Bearer ';
export const REQUEST_HEADER_AUTH_KEY = 'Authorization';
export const API_BASE_URL = isProduction
	? 'https://prakash-backend-express.vercel.app'
	: 'http://localhost:4000';
